// Muestra la barra flotante de "Agregar al carrito" cuando el boton real
// de compra sale de la vista (scroll hacia abajo), la esconde cuando vuelve
// a estar visible. Al hacer click en la barra, dispara el boton real en vez
// de duplicar el formulario -- una sola fuente de verdad para variante/qty.
//
// Tambien replica las opciones del producto (colores, tallas...) como chips
// dentro de la barra: cada chip dispara el input real, asi la logica de
// variantes de Dawn (precio, imagen, disponibilidad) sigue siendo la unica.
(function () {
  const MAX_INLINE_VALUES = 6;
  let barVisible = false;

  // Las burbujas flotantes (WhatsApp, Ofertas, etc.) estan colocadas para una
  // barra de ~64px. Cuando la barra es mas alta por las opciones, se suben el
  // excedente via --rechilero-atc-offset para que no queden encima.
  function updateOffset(bar) {
    const extra = barVisible ? Math.max(0, bar.offsetHeight - 64) : 0;
    document.documentElement.style.setProperty('--rechilero-atc-offset', `${extra}px`);
  }

  function init() {
    const bar = document.querySelector('[data-rechilero-sticky-atc]');
    const realButton = document.querySelector('.product-form__buttons button[name="add"]');
    if (!bar || !realButton) return;

    const barButton = bar.querySelector('[data-rechilero-sticky-atc-button]');
    barButton.addEventListener('click', () => realButton.click());

    setupOptions(bar);
    // La barra cambia de alto cuando cambian las opciones (filas de colores).
    new ResizeObserver(() => updateOffset(bar)).observe(bar);

    const observer = new IntersectionObserver(
      (entries) => {
        const realButtonVisible = entries[0].isIntersecting;
        bar.hidden = false;
        bar.classList.toggle('rechilero-sticky-atc--visible', !realButtonVisible);
        barVisible = !realButtonVisible;
        updateOffset(bar);
      },
      { rootMargin: '0px 0px -10% 0px' }
    );
    observer.observe(realButton);
  }

  // Lee las opciones desde el DOM real (radios o selects). Se vuelve a leer
  // en cada render porque Dawn puede reemplazar el picker al cambiar variante.
  function readOptions() {
    const selects = document.querySelector('variant-selects');
    if (!selects) return [];
    const groups = [];

    selects.querySelectorAll('fieldset').forEach((fieldset) => {
      const values = [...fieldset.querySelectorAll('input[type="radio"]')].map((input) => {
        const label = fieldset.querySelector(`label[for="${input.id}"]`);
        return {
          name: input.dataset.optionName || input.name,
          value: input.value,
          checked: input.checked,
          unavailable: input.classList.contains('disabled') || label?.classList.contains('disabled'),
          swatch: label?.querySelector('.swatch'),
          input,
        };
      });
      if (values.length) groups.push({ name: values[0].name, values });
    });

    selects.querySelectorAll('select').forEach((select) => {
      const values = [...select.options].map((option) => ({
        name: option.dataset.optionName,
        value: option.value,
        checked: option.selected,
        unavailable: false,
        select,
      }));
      if (values.length) groups.push({ name: values[0].name, values });
    });

    return groups;
  }

  function selectOption(optionName, value) {
    const selects = document.querySelector('variant-selects');
    if (!selects) return;
    const radio = [...selects.querySelectorAll('input[type="radio"]')].find(
      (input) => (input.dataset.optionName || input.name) === optionName && input.value === value
    );
    if (radio) {
      radio.click();
      return;
    }
    const option = [...selects.querySelectorAll('select option')].find(
      (o) => o.dataset.optionName === optionName && o.value === value
    );
    if (option) {
      const select = option.closest('select');
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function setupOptions(bar) {
    const container = bar.querySelector('[data-rechilero-sticky-options]');
    if (!container) return;

    function render() {
      container.replaceChildren();
      readOptions().forEach((group) => {
        const row = document.createElement('div');
        row.className = 'rechilero-sticky-atc__group';

        const name = document.createElement('span');
        name.className = 'rechilero-sticky-atc__group-name';
        const selected = group.values.find((item) => item.checked);
        name.append(`${group.name}: `);
        const selectedName = document.createElement('span');
        selectedName.textContent = selected ? selected.value : '';
        name.append(selectedName);

        // Boton que abre la hoja con miniaturas y cantidad por variante.
        const openSheet = document.createElement('button');
        openSheet.type = 'button';
        openSheet.className = 'rechilero-sticky-atc__more';
        openSheet.textContent =
          group.values.length > MAX_INLINE_VALUES
            ? `Ver los ${group.values.length} y elegir cantidad`
            : 'Elegir cantidad';
        openSheet.addEventListener('click', () => openVariantSheet(group));
        const head = document.createElement('div');
        head.className = 'rechilero-sticky-atc__group-head';
        head.append(name, openSheet);

        const chips = document.createElement('div');
        chips.className = 'rechilero-sticky-atc__chips';

        group.values.forEach((item) => {
          const chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'rechilero-sticky-atc__chip';
          chip.setAttribute('aria-pressed', String(item.checked));
          if (item.unavailable) chip.dataset.unavailable = '';
          if (item.swatch) {
            chip.classList.add('rechilero-sticky-atc__chip--swatch');
            chip.title = item.value;
            chip.setAttribute('aria-label', item.value);
            chip.append(item.swatch.cloneNode(true));
          } else {
            chip.append(item.value);
          }
          // El input real se busca al hacer click: Dawn reemplaza el picker
          // tras cada cambio de variante, y las referencias guardadas al
          // renderizar quedan apuntando a nodos que ya no estan en la pagina.
          chip.addEventListener('click', () => selectOption(group.name, item.value));
          chips.append(chip);
        });

        row.append(head);
        // Con muchas opciones los circulos ocuparian varias filas: se dejan
        // solo dentro de la hoja.
        if (group.values.length <= MAX_INLINE_VALUES) row.append(chips);
        container.append(row);
      });
    }

    render();
    // Dawn reemplaza/actualiza el picker de forma asincrona tras cada cambio.
    // PUB_SUB_EVENTS es un const global (no cuelga de window).
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, () => {
        render();
        syncPrice(bar);
      });
    }
    document.addEventListener('change', (event) => {
      if (event.target.closest?.('variant-selects')) render();
    });
  }


  // ---- Hoja inferior (estilo Alibaba): miniatura + cantidad por variante ----

  let productPromise;
  function loadProduct() {
    const handle = location.pathname.split('/products/')[1]?.split('/')[0];
    productPromise ||= fetch(`/products/${handle}.js`).then((r) => r.json());
    return productPromise;
  }

  function money(cents) {
    const currency = window.Shopify?.currency?.active || '';
    return `${(cents / 100).toFixed(2)} ${currency}`.trim();
  }

  function thumbUrl(src, width) {
    const url = new URL(src, location.origin);
    url.searchParams.set('width', width);
    return url.toString();
  }


  // Tramos de precio por volumen. El descuento real lo aplica Shopify en el
  // checkout (descuentos automaticos por producto) y no se expone al
  // storefront; el mismo tramo esta publicado como tabla en la descripcion
  // ("3 a 11 pares | Q33.33"), asi que se lee de ahi para mostrarle al cliente
  // su ahorro antes de pagar. Si no hay tabla, la hoja funciona sin ahorro.
  function readTiers() {
    const table = document.querySelector('.product__description table');
    if (!table) return [];
    const tiers = [...table.querySelectorAll('tbody tr')]
      .map((tr) => {
        const [qty, price] = [...tr.cells].map((td) => td.textContent);
        const min = parseInt((qty || '').match(/\d+/)?.[0], 10);
        const unit = parseFloat((price || '').replace(/[^\d.]/g, ''));
        return { min, unit: Math.round(unit * 100) };
      })
      .filter((t) => Number.isFinite(t.min) && t.unit > 0)
      .sort((a, b) => a.min - b.min);
    return tiers;
  }

  async function cartUnitsOf(productId) {
    try {
      const cart = await (await fetch('/cart.js')).json();
      return cart.items.filter((i) => i.product_id === productId).reduce((sum, i) => sum + i.quantity, 0);
    } catch (e) {
      return 0;
    }
  }

  async function openVariantSheet(group) {
    if (document.querySelector('.rechilero-sheet')) return;
    const swatches = new Map(group.values.map((item) => [item.value, item.swatch]));
    const sheet = document.createElement('div');
    sheet.className = 'rechilero-sheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.innerHTML = `
      <div class="rechilero-sheet__backdrop" data-close></div>
      <div class="rechilero-sheet__panel">
        <div class="rechilero-sheet__header">
          <strong>Elegí ${group.name.toLowerCase()} y cantidad</strong>
          <button type="button" class="rechilero-sheet__close" data-close aria-label="Cerrar">&times;</button>
        </div>
        <div class="rechilero-sheet__list" data-list>Cargando...</div>
        <div class="rechilero-sheet__footer">
          <div class="rechilero-sheet__total" data-total></div>
          <p class="rechilero-sheet__error" data-error hidden></p>
          <button type="button" class="rechilero-btn rechilero-btn--primary" data-add disabled>Agregar al carrito</button>
        </div>
      </div>`;
    document.body.append(sheet);
    document.body.style.overflow = 'hidden';

    const close = () => {
      sheet.remove();
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
    };
    const onKey = (e) => e.key === 'Escape' && close();
    document.addEventListener('keydown', onKey);
    sheet.querySelectorAll('[data-close]').forEach((el) => el.addEventListener('click', close));

    let product;
    try {
      product = await loadProduct();
    } catch (e) {
      sheet.querySelector('[data-list]').textContent = 'No se pudieron cargar las opciones.';
      return;
    }

    const tiers = readTiers();
    const inCart = tiers.length ? await cartUnitsOf(product.id) : 0;
    const list = sheet.querySelector('[data-list]');
    const totalEl = sheet.querySelector('[data-total]');
    const addButton = sheet.querySelector('[data-add]');
    const errorEl = sheet.querySelector('[data-error]');
    const rows = [];
    list.replaceChildren();

    product.variants.forEach((variant) => {
      const row = document.createElement('div');
      row.className = 'rechilero-sheet__row';
      if (!variant.available) row.classList.add('rechilero-sheet__row--soldout');

      const thumb = document.createElement('div');
      thumb.className = 'rechilero-sheet__thumb';
      if (variant.featured_image) {
        const img = document.createElement('img');
        img.src = thumbUrl(variant.featured_image.src, 120);
        img.alt = '';
        img.loading = 'lazy';
        thumb.append(img);
      } else {
        // Sin foto propia para esta variante: se usa la muestra de color.
        const swatch = swatches.get(variant.option1)?.cloneNode(true);
        if (swatch) thumb.append(swatch);
        else thumb.textContent = variant.title.slice(0, 1);
      }

      const label = document.createElement('div');
      label.className = 'rechilero-sheet__label';
      const title = document.createElement('span');
      title.textContent = variant.title;
      const sub = document.createElement('small');
      sub.textContent = variant.available ? money(variant.price) : 'Agotado';
      label.append(title, sub);

      const stepper = document.createElement('div');
      stepper.className = 'rechilero-sheet__stepper';
      const minus = document.createElement('button');
      const plus = document.createElement('button');
      const input = document.createElement('input');
      minus.type = plus.type = 'button';
      minus.textContent = '−';
      plus.textContent = '+';
      minus.setAttribute('aria-label', `Quitar ${variant.title}`);
      plus.setAttribute('aria-label', `Agregar ${variant.title}`);
      input.type = 'number';
      input.inputMode = 'numeric';
      input.min = '0';
      input.value = '0';
      input.disabled = minus.disabled = plus.disabled = !variant.available;
      const set = (n) => {
        input.value = String(Math.max(0, Math.min(9999, Number(n) || 0)));
        row.classList.toggle('rechilero-sheet__row--active', Number(input.value) > 0);
        update();
      };
      minus.addEventListener('click', () => set(Number(input.value) - 1));
      plus.addEventListener('click', () => set(Number(input.value) + 1));
      input.addEventListener('change', () => set(input.value));
      stepper.append(minus, input, plus);

      row.append(thumb, label, stepper);
      list.append(row);
      rows.push({ variant, input, row });
    });

    function tierFor(units) {
      return [...tiers].reverse().find((t) => units >= t.min);
    }

    function line(className, text) {
      const el = document.createElement('div');
      el.className = className;
      el.textContent = text;
      return el;
    }

    function update() {
      const picked = rows.filter((r) => Number(r.input.value) > 0);
      const units = picked.reduce((sum, r) => sum + Number(r.input.value), 0);
      const basePrice = product.variants[0].price;
      const baseCents = picked.reduce((sum, r) => sum + Number(r.input.value) * r.variant.price, 0);
      totalEl.replaceChildren();
      addButton.disabled = units === 0;

      // El descuento cuenta TODO lo del mismo producto, incluido lo que ya
      // esta en el carrito.
      const combined = units + inCart;
      const tier = tiers.length ? tierFor(combined) : null;
      const unit = tier ? Math.min(tier.unit, basePrice) : basePrice;
      const cents = units * unit;
      const saved = units ? baseCents - cents : 0;

      rows.forEach((r) => {
        const sub = r.row.querySelector('small');
        if (!r.variant.available) return;
        sub.textContent = unit < r.variant.price ? `${money(unit)} c/u` : money(r.variant.price);
      });

      if (!units) {
        totalEl.append(line('rechilero-sheet__units', 'Elegí al menos una unidad'));
        const first = tiers.find((t) => t.unit < basePrice);
        if (first) totalEl.append(line('rechilero-sheet__hint', `Desde ${first.min} unidades pagás ${money(first.unit)} c/u`));
        return;
      }

      totalEl.append(line('rechilero-sheet__units', `${units} ${units === 1 ? 'unidad' : 'unidades'}`));
      const price = line('rechilero-sheet__price', money(cents));
      if (saved > 0) {
        const was = document.createElement('s');
        was.textContent = money(baseCents);
        price.prepend(was);
      }
      totalEl.append(price);
      if (saved > 0) {
        const pct = Math.round((saved / baseCents) * 100);
        totalEl.append(line('rechilero-sheet__saving', `Ahorrás ${money(saved)} (${pct}%)`));
      }
      if (inCart && tier) {
        totalEl.append(line('rechilero-sheet__hint', `Contando las ${inCart} que ya tenés en el carrito`));
      }
      const next = tiers.find((t) => t.min > combined && t.unit < unit);
      if (next) {
        const missing = next.min - combined;
        totalEl.append(
          line('rechilero-sheet__hint rechilero-sheet__hint--next', `Agregá ${missing} más y pagá ${money(next.unit)} c/u`)
        );
      }
    }
    update();

    addButton.addEventListener('click', async () => {
      const items = rows
        .filter((r) => Number(r.input.value) > 0)
        .map((r) => ({ id: r.variant.id, quantity: Number(r.input.value) }));
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      addButton.disabled = true;
      addButton.textContent = 'Agregando...';
      errorEl.hidden = true;
      try {
        const body = { items };
        if (cart) {
          body.sections = cart.getSectionsToRender().map((section) => section.id).join(',');
          body.sections_url = window.location.pathname;
        }
        const response = await fetch(window.routes.cart_add_url.replace(/\.js$/, '') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || data.message || 'No se pudo agregar');
        close();
        if (cart) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rechilero-sheet', cartData: data });
          cart.renderContents(data);
        } else {
          window.location = window.routes.cart_url;
        }
      } catch (e) {
        errorEl.textContent = e.message;
        errorEl.hidden = false;
        addButton.disabled = false;
        addButton.textContent = 'Agregar al carrito';
      }
    });
  }

  function syncPrice(bar) {
    const target = bar.querySelector('.rechilero-sticky-atc__price');
    const source = document.querySelector('.product__info-container .price .price-item--last');
    if (target && source) target.textContent = source.textContent.trim();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
